import { SvgIcon, SvgIconProps } from '@mui/material'

const ArrowRight = (props: SvgIconProps) => {
  return (
    <SvgIcon role="img" viewBox="0 0 24 24" {...props}>
      <path
        d="M15.707 11.293 9.71 5.294c-.63-.63-1.707-.184-1.707.707v11.997c0 .891 1.077 1.337 1.707.707l5.997-5.998a1 1 0 0 0 0-1.415Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export default ArrowRight
